export default "__VITE_ASSET__ygonxD$y__"